export default __webpack_public_path__ + "images/5b12a948aeb17b2341d74a4394bedaa4.svg";